import { stallionCommonEnvironment } from '@environments/stallion/environment.common';
import { AppEnvironment } from '@models/app-environment';

/**
 * Environment variables for use on the Stallion site, in production environment.
 */
export const environment: AppEnvironment = {
  ...stallionCommonEnvironment,
  production: true,
  apiUrl: 'https://api.analytecare.com',
  analyteCareApi: 'https://api.analytecare.com',
  googleMapApiKey: 'AIzaSyDIEZHrvUCVq39wvL0mBOanghqkHIk8cRE',
  braintreeToken: 'production_csgfcd5t_53b8hvj83v98kzmr',
  googlePay: {
    merchantId: 'BCR2DN4TQ3K3DXR3',
    apiVersion: 2,
    apiVersionMinor: 0,
  },
  defaultOrderLabId: '27349',
  oncehubSchedulingUrl: 'https://go.oncehub.com',
  siteUrls: {
    home: 'https://www.stallion.com',
    termsOfService: 'https://www.stallion.com/terms-conditions/',
    myAccount: 'https://my-account.stallion.com',
    tests: 'https://www.stallion.com',
    notFound: 'https://www.stallion.com/404',
  },
  ngFindalab: {
    ...stallionCommonEnvironment.ngFindalab,
    inHomeCollectionAllowed: false,
  },
};
